import { FC, SVGProps } from 'react';

export const MailIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='20' height='20' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M67.8571 15H12.1429C10.9115 15 9.73057 15.5268 8.85986 16.4645C7.98916 17.4021 7.5 18.6739 7.5 20V60C7.5 61.3261 7.98916 62.5979 8.85986 63.5355C9.73057 64.4732 10.9115 65 12.1429 65H67.8571C69.0885 65 70.2694 64.4732 71.1401 63.5355C72.0108 62.5979 72.5 61.3261 72.5 60V20C72.5 18.6739 72.0108 17.4021 71.1401 16.4645C70.2694 15.5268 69.0885 15 67.8571 15ZM62.75 20L40 36.95L17.25 20H62.75ZM12.1429 60V22.275L38.6768 42.05C39.0654 42.3403 39.5271 42.4959 40 42.4959C40.4729 42.4959 40.9346 42.3403 41.3232 42.05L67.8571 22.275V60H12.1429Z'
			fill='currentColor'
		/>
	</svg>
);
